import { ReferentielModel } from './referentiel.model';
import { WorkMiloModel } from './referential/work-milo.model';
import { ProductDiscModel } from './product-disc.model';
import { TerritoryModel } from './milo/territory.model';
import { ProductBoxSetModel } from './product-box-set.model';
import { ProductTypeModel } from './product-type.model';
import { UserVideoModel } from './user-video.model';
import { ThirdPartyModel } from './referential/third-party.model';
import { ProductDivisionModel } from './product-division.model';

export class ProductModel {
  public id: number = null;
  public support: ReferentielModel = new ReferentielModel();
  public productType: ProductTypeModel = new ProductTypeModel();
  public exploitation: ReferentielModel = new ReferentielModel();
  public label: ReferentielModel = new ReferentielModel();
  public category: ReferentielModel = new ReferentielModel();
  public companyId: number = null;
  public companyCode: string = null;
  public editorId: number = null;
  public editor: ReferentielModel = new ReferentielModel();
  public status: ReferentielModel = new ReferentielModel();
  public distributor: ReferentielModel = new ReferentielModel();
  public productManager: UserVideoModel = new UserVideoModel();
  public projectManager: UserVideoModel = new UserVideoModel();
  public manufacturingManager: UserVideoModel = new UserVideoModel();
  public designer: ThirdPartyModel = new ThirdPartyModel();
  public pressOfficer: ThirdPartyModel = new ThirdPartyModel();
  public title: string = null;
  public descriptive: string = null;
  public releaseDate = null;
  public theatricalReleaseDate = null;
  public initialGoal: number = null;
  public numberOfDisc: number = null;
  public achievedGoal: number = null;
  public ean: string = null;
  public articleNumber: string = null;
  public pght: any = null;
  public notes: string = null;
  public productWorks: WorkMiloModel[] = [];
  public productDivisions: ProductDivisionModel[] = [];
  public territories: TerritoryModel[] = [];
  public productDiscs: ProductDiscModel[] = [];
  public productBoxSets: ProductBoxSetModel[] = [];
  public financialDistributionInitialized: boolean;
  public numFED: string = null;
  public designerCode = '';
  public pressOfficerCode = '';
  public formattedEan: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }

  public fromJSONs(jsons) {
    const refs: ProductModel[] = [];
    if (jsons) {
      jsons.forEach(json => {
        refs.push(new ProductModel().fromJSON(json));
      });
    }
    return refs;
  }
}
